const React = require("react");
const _ = require("lodash");
const AssetsUtil = require("./AssetsUtil");
const StarBar = require("../view/StarProgressStandard");
const Avatar = require("../view/Avatar");
const ComputerScreenshot = require("../view/ComputerScreenshot");
const ColorUtil = require("./ColorUtil");
const StatsIcon = require("../view/StatsIcon");

const GradeGraph = require("../../report/GradeGraph");
const GradeBarGraph = require("../../report/GradeBarGraph");
const HistoryIcon = require("../../office/HistoryIcon");
const LockIcon = require("../../office/LockIcon");
const PieGraph = require("../view/PieGraph");
const InfoIcon = require("../../office/InfoIcon");
const Editable = require("../../office/Editable");
const ToggleItem = require("../../office/ToggleItem");
const CopyTable = require("../../office/data/CopyTable");
const HomeworkIcon = require("../view/HomeworkIcon");

const sampleAvatar = {
	color: "#8dc349",
	num: 4,
};

const parseNewlinesToReact = function(inputString) {
	const lineArray = inputString.split("\n");
	// Only convert if necessary to avoid excess markup
	if (lineArray.length === 1) return inputString;
	const contentArray = [];
	// React complains about arrays that don't have keys specified
	// so we add placeholder divs here.
	for (let i = 0; i < lineArray.length; i++) {
		const br = i === lineArray.length - 1 ? null : <br />;
		contentArray.push(
			<div key={"stringline" + i}>
				{lineArray[i]}
				{br}
			</div>
		);
	}
	return <div>{contentArray}</div>;
};

const detailIcon = function(styles, iconSrc, text, extraClass) {
	let iconClass = styles.detailIcon;
	if (_.isString(extraClass)) {
		iconClass += " " + extraClass;
	} else if (extraClass) {
		iconClass += " " + styles.iconShadow;
	}
	let icon;
	if (_.isObject(iconSrc) || iconSrc === "avatar") {
		if (iconSrc.num || iconSrc === "avatar") {
			const avatar = _.isObject(iconSrc) ? iconSrc : sampleAvatar;
			icon = (
				<Avatar
					className={extraClass || styles.detailAvatar}
					hasSurround={true}
					avatar={avatar}
				/>
			);
		} else {
			icon = iconSrc;
		}
	} else {
		icon = <img className={iconClass} src={iconSrc} />;
	}

	return (
		<div className={styles.outer}>
			{icon}
			{text}
		</div>
	);
};

const teacherIcon = function(styles) {
	return genericIcon(
		styles,
		AssetsUtil.getButton("teacher-blue"),
		"teacherOuter",
		"teacherIcon"
	);
};

const genericIcon = function(styles, iconSrc, outerClass, innerClass) {
	const outer = outerClass || "inlineOuter";
	const inner = innerClass || "inlineIcon";

	return (
		<span className={styles[outer]}>
			<img className={styles[inner]} src={iconSrc} />
		</span>
	);
};

const inlineIcon = function(styles, iconSrc, type, direction) {
	let iconClass = styles.inlineIcon;
	if (type) iconClass += " " + styles[type + "Icon"];
	if (direction) iconClass += " " + styles[direction];

	let icon;

	if (type === "avatar") {
		icon = (
			<Avatar
				className={styles.inlineAvatar}
				hasSurround={true}
				avatar={sampleAvatar}
			/>
		);
	} else if (type === "sequenceSliderTab") {
		icon = (
			<div className={styles.toggle}>
				<img
					className={styles.icon}
					src={AssetsUtil.getImageForGrade(3, "white")}
				/>
			</div>
		);
	} else {
		icon = <img className={iconClass} src={iconSrc} />;
	}

	return <span className={styles.inlineOuter}>{icon}</span>;
};

const starBar = function(styles, filledAmount, text) {
	return (
		<div className={styles.outerBar}>
			<StarBar
				className={styles.starBar}
				filledAmount={filledAmount}
				totalAmount={10}
				allCutoffs={[10, 8, 6]}
				starCutoffs={[10, 8, 6]}
			/>
			{text}
		</div>
	);
};

const attemptsBar = function(styles, data) {
	_.each(data.results, (r, i) => {
		r.id = data.id + "-" + i;
	});

	const {results} = data;

	const renderAttempt = function(result) {
		return (
			<HistoryIcon
				key={"result" + result.id}
				iconClass={styles.circle}
				finishStatus={result.finishStatus}
				numStars={result.numStars}
				hideStarIcon={true}
				percentComplete={result.percentComplete}
			/>
		);
	};

	let attempts, more, lastAttempt;
	if (results.length > 5) {
		attempts = _.map(_.take(results, 3), r => renderAttempt(r));
		more = (
			<span className={styles.more}>
				{`+${results.length - 4}`}
				<br />
				{"..."}
			</span>
		);
		lastAttempt = renderAttempt(_.last(results));
	} else {
		attempts = _.map(results, r => renderAttempt(r));
	}

	return (
		<div className={styles.attemptsOuter}>
			{attempts}
			{more}
			{lastAttempt}
		</div>
	);
};

const screenshot = function(styles, screenshotName, withBorder, overrideClass) {
	const src = AssetsUtil.getScreenshot(screenshotName);
	const ssClass =
		overrideClass || styles[screenshotName] || styles.defaultScreenshot;
	const screenshotEl = withBorder ? (
		<ComputerScreenshot
			screenshotType={screenshotName}
			computerType="laptop-black"
			className={styles.defaultScreenshot}
		/>
	) : (
		<img className={styles.screenshotImg} src={src} />
	);

	return (
		<div className={styles.screenshot}>
			<div className={ssClass}>{screenshotEl}</div>
		</div>
	);
};

const sliderTab = function(styles, gradeNumber, text, demo, isAdminOrTeacher) {
	if (isAdminOrTeacher) {
		return (
			<div className={styles.outer}>
				<div className={styles.sliderTabMainTeacher}>
					<div className={styles.sliderIcon}>
						<img
							src={AssetsUtil.getTrayImageForTeacher("sequence-slider-tab")}
						/>
					</div>
					<div className={styles.sliderIcon}>
						<img src={AssetsUtil.getTrainerIconButton("hamburger-teacher")} />
					</div>
				</div>
				{text}
			</div>
		);
	}
	const sliderImage = demo ? (
		<img
			className={styles.sliderDemo}
			src={AssetsUtil.getButton("index-demo")}
		/>
	) : (
		<img
			className={styles.sliderGrade}
			src={AssetsUtil.getImageForGrade(gradeNumber, "white")}
		/>
	);

	return (
		<div className={styles.outer}>
			<div className={styles.sliderTabMain}>
				<div className={styles.sliderIcon}>
					<img
						className={styles.sliderTab}
						src={AssetsUtil.getTrayImageByGrade(
							"sequence-slider-tab",
							demo ? "demo" : gradeNumber
						)}
					/>
					{sliderImage}
				</div>
			</div>
			{text}
		</div>
	);
};

const getLegendInfo = function() {
	return {
		locks: [
			{
				isLocked: true,
				isForced: false,
				full: "Automatically locked",
				short: "Auto. locked",
			},
			{
				isLocked: false,
				isForced: false,
				full: "Automatically unlocked",
				short: "Auto. unlocked",
			},
			{
				isLocked: true,
				isForced: true,
				full: "Manually locked",
				short: "Manual locked",
			},
			{
				isLocked: false,
				isForced: true,
				full: "Manually unlocked",
				short: "Manual unlocked",
			},
		],
		colors: {
			3: "3 stars - Expert",
			2: "2 stars - Advanced",
			1: "1 star - Proficient",
			0: "0 stars - Needs Practice",
			incomplete: "Incomplete",
			intervened:
				"Alert! The lesson was ended early after a student missed some early questions, or they quit a test. They may need help.",
		},
		colorsShort: {
			3: "3 stars - Expert",
			2: "2 stars - Advanced",
			1: "1 star - Proficient",
			0: "0 stars - Needs Practice",
			incomplete: "Incomplete",
			intervened: "Needs help",
		},
		celestialsShort: {
			3: "Galaxy Sets (Master)",
			2: "Planet Sets (Expert)",
			1: "Comet Sets (Advanced)",
			0: "Moon Sets (Intermediate)",
		},
		icons: {
			star: "Stars",
			trophy: "Trophies",
			xp: "Experience points",
			time: "Time spent",
			beast: "Beast",
			check: "Problems correct",
			moon: "Moon Sets",
			comet: "Comet Sets",
			planet: "Planet Sets",
			galaxy: "Galaxy Sets",
		},
		history: {
			stars: "Stars earned",
			partial: "Partially completed",
			intervened: "Needs help",
		},
	};
};

// Currently unused
const lockLegend = function(styles) {
	const {locks} = getLegendInfo();

	const lockEls = locks.map((obj, i) => {
		return (
			<div key={"lock" + i} className={styles.outer}>
				<LockIcon
					className={styles.lock}
					isLocked={obj.isLocked}
					isForced={obj.isForced}
					disabled={true}
				/>
				<span className={styles.locksFull}>{obj.full}</span>
				<span className={styles.locksShort}>{obj.short}</span>
			</div>
		);
	});

	return lockEls;
};

const lockIcon = function(styles, type, copy, outerClass) {
	let status;
	if (type === "classLock") {
		status = {
			isForced: false,
			isLocked: false,
			useKeyIcon: true,
		};
	} else if (type === "autoLocked") {
		status = {
			isForced: false,
			isLocked: true,
		};
	} else if (type === "autoUnlocked") {
		status = {
			isForced: false,
			isLocked: false,
		};
	} else if (type === "forceLocked") {
		status = {
			isForced: true,
			isLocked: true,
		};
	} else if (type === "forceUnlocked") {
		status = {
			isForced: true,
			isLocked: false,
		};
	}

	return (
		<div className={outerClass || styles.outer}>
			<LockIcon className={styles.lock} {...status} disabled={true} />
			{copy}
		</div>
	);
};

const colorLegend = function(styles, forTeacher) {
	const {colors, colorsShort} = getLegendInfo();
	const starColors = _.reverse(ColorUtil.getBlueStarColors(4));

	const colorsIndices = forTeacher
		? [3, 2, 1, 0, "incomplete", "intervened"]
		: [3, 2, 1, 0];
	const starKeyEls = colorsIndices.map(i => {
		let backgroundColor;
		if (i === "incomplete") {
			backgroundColor = ColorUtil.getCurrentScheme().lighterGrayFill;
		} else if (i === "intervened") {
			backgroundColor = ColorUtil.getCurrentScheme().incorrectFill;
		} else {
			backgroundColor = starColors[i];
		}
		const blockStyle = {backgroundColor};

		return (
			<div key={"star" + i} className={styles.outer}>
				<div className={styles.color} style={blockStyle} />
				<span className={styles.colorsFull}>{colors[i]}</span>
				<span className={styles.colorsShort}>{colorsShort[i]}</span>
			</div>
		);
	});

	return starKeyEls;
};

const gradeExample = function(styles) {
	const data = [
		[[3, 2, 2, 2, 2, 0]],
		[[3, 3, 2, 1, 0, -1]],
		[[3, 3, 3, 3, 1, 1, 0, -1, -1, -1]],
		[[3, 3, 2, 1, 1, 1, 1, 0, -1, -1, -1, -1, -1]],
	];
	return (
		<GradeGraph
			className={styles.exampleGrade}
			gradeID={0}
			barDataChapters={data}
			backgroundColor={ColorUtil.getCurrentScheme().lighterGrayFill}
			disableResponsive={true}
		/>
	);
};

const chapterExample = function(styles) {
	const data = [3, 3, 2, 1, 0, 1, 0, 2, 3, -1, -1, -1];
	const hoverContent = data.map((n, i) => "Lesson " + (i + 1));
	return (
		<GradeBarGraph
			className={styles.exampleChapter}
			gradeID={0}
			barData={[data]}
			backgroundColor={ColorUtil.getCurrentScheme().lighterGrayFill}
			hoverContent={[hoverContent]}
		/>
	);
};

const lessonExample = function(styles) {
	return (
		<div className={styles.exampleLesson}>
			<HistoryIcon type={"intervened"} grayBackground={true} />
			<HistoryIcon type={"stars"} numStars={2} />
			<HistoryIcon type={"stars"} numStars={3} />
			<HistoryIcon
				type={"partial"}
				percentComplete={0.1}
				grayBackground={true}
			/>
		</div>
	);
};

const historyIcon = function(styles, type, whiteBg, customCopy, opts) {
	const {history} = getLegendInfo();
	const options = opts || {};
	const {
		hasTrophy,
		trophyAvailable,
		hideStarIcon,
		keySuffix,
		celestialEarned,
		backgroundIconType,
	} = options;
	const numStars = options.numStars === undefined ? 2 : options.numStars;
	const percentComplete = _.isNumber(options.percentComplete)
		? options.percentComplete
		: 0.25;
	const key = keySuffix || type;

	const histIcon = (
		<HistoryIcon
			iconClass={styles.icon}
			type={type}
			numStars={numStars}
			hasTrophy={hasTrophy}
			trophyAvailable={trophyAvailable}
			percentComplete={percentComplete}
			celestialEarned={celestialEarned}
			grayBackground={!whiteBg}
			hideStarIcon={hideStarIcon}
			backgroundIconType={backgroundIconType}
		/>
	);

	if (options.inline) {
		return (
			<div key={"history" + key} className={styles.inlineHistory}>
				{histIcon}
			</div>
		);
	} else {
		return (
			<div key={"history" + key} className={styles.outer}>
				{histIcon}
				{customCopy || history[type]}
			</div>
		);
	}
};

const pieGraphIcon = function(styles, customCopy, pieInfo, scheme) {
	const starColors =
		scheme === "purple"
			? _.reverse(ColorUtil.getPurpleCelestialColors(4))
			: _.reverse(ColorUtil.getBlueStarColors(4));

	const data = _.map(pieInfo, slice => {
		let color;
		if (_.isInteger(slice.color)) {
			color = starColors[slice.color];
		} else if (slice.color === "red") {
			color = ColorUtil.getCurrentScheme().incorrectFill;
		} else if (slice.color === "green") {
			color = ColorUtil.getCurrentScheme().correctFill;
		} else if (slice.color === "orange") {
			color = ColorUtil.getCurrentScheme().skippedFill;
		}
		return {color, percent: slice.percent};
	});

	return (
		<div className={styles.outer}>
			<PieGraph className={styles.icon} data={data} />
			{customCopy}
		</div>
	);
};

const statsIcon = function(styles, type, customCopy, extraClass) {
	const {icons} = getLegendInfo();

	let iconClass = styles.icon;
	if (extraClass) iconClass += " " + extraClass;

	return (
		<div key={"icon" + type} className={styles.outer}>
			<StatsIcon className={iconClass} style="office" type={type} />
			{customCopy || icons[type]}
		</div>
	);
};

const accountSetting = function(styles, type) {
	const options = CopyTable.getAccountOptions({type});
	let editText;
	if (type !== "beast") {
		switch (type) {
			case "lockSettings":
				editText = "Free Play";
				break;
			case "fixedSets":
				editText = "Fixed Order";
				break;
			case "displayedGrade":
				editText = "4";
				break;
			case "schoolGrade":
				editText = "3";
				break;
			default:
				editText = _.last(options.options).label;
				break;
		}
	}

	const editableEl =
		type === "beast" ? (
			<ToggleItem
				className={styles.settingEditable}
				onToggle={() => {}}
				isOn={true}
			/>
		) : (
			<Editable
				className={styles.settingEditable}
				onClick={() => {}}
				text={editText}
				editContainerClass={styles.edit}
			/>
		);

	return (
		<div className={styles.settingsItem}>
			<div className={styles.settingsItemTop}>
				<InfoIcon
					text={options.info}
					title={options.title}
					isModal={true}
					className={styles.info}
				/>
				<div className={styles.settingLabel}>{options.infoTitle}</div>
			</div>
			{editableEl}
		</div>
	);
};

const homeworkIcon = function(styles, type, opts, copy, outerClass) {
	return (
		<div className={outerClass || styles.outer}>
			<HomeworkIcon
				className={styles.homework}
				disabled={opts.disabled || false}
				disabledText={""}
				onClick={_.noop}
				isAssigned={type === "assigned"}
				size={"small"}
				noTooltip={true}
				isAcademy={opts.isAcademy || false}
			/>
			{copy}
		</div>
	);
};

module.exports = {
	parseNewlinesToReact,
	detailIcon,
	genericIcon,
	teacherIcon,
	inlineIcon,
	starBar,
	attemptsBar,
	screenshot,
	sliderTab,
	lockLegend,
	lockIcon,
	colorLegend,
	gradeExample,
	chapterExample,
	lessonExample,
	historyIcon,
	pieGraphIcon,
	statsIcon,
	accountSetting,
	getLegendInfo,
	homeworkIcon,
};
